<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">

      <div class="card">
        <div class="card-body text-center">

          <div class="mb-4">
            <i class="fas fa-check-circle text-success fa-4x"></i>
          </div>

          <h2 class="text-success">
            Payment Successful
          </h2>

          <hr>

          <p>
            Your payment has been received and your form was successfully submitted.
          </p>

          <div
            class="alert alert-success mt-4"
            *ngIf="formTransactionId">

            Confirmation Number:
            <strong>
              TR-{{ formTransactionId }}
            </strong>

          </div>

          <p class="mt-3">
            A confirmation email will be sent if configured by the church.
          </p>

          <a
            class="btn btn-primary mt-3 text-light"
            (click)="goHome()">
            Return Home
          </a>

        </div>
      </div>

    </div>
  </div>
</div>